import { AddWrestlerStepsEnum } from './AddWrestlerUtils';
import WrestlerBirthStep from './WrestlerBirthStep';
import WrestlerInviteStep from './WrestlerInviteStep';
import WrestlerNameStep from './WrestlerNameStep';
import WrestlerStatsStep from './WrestlerStatsStep';
import { log } from '@utils/logging';

interface StepProps {
    step: number;
    // goToPrevStep: () => void;
    // goToNextStep: () => void;
}

export default function AddWrestlerSteps(props: StepProps) {
    const { step } = props;

    switch (step) {
        case AddWrestlerStepsEnum.WRESTLER_NAME:
            return <WrestlerNameStep />;
        case AddWrestlerStepsEnum.WRESTLER_BIRTH:
            return <WrestlerBirthStep />;
        case AddWrestlerStepsEnum.WRESTLER_STATS:
            return <WrestlerStatsStep />;
        case AddWrestlerStepsEnum.WRESTLER_INVITE:
            return <WrestlerInviteStep />;
        default:
            log(`Invalid Add Wrestler step reached: ${step}`);
            return null;
    }
}
